import { Component, ElementRef, ViewChild } from '@angular/core';

@Component({
  selector: 'app-cardlink',
  templateUrl: './cardlink.component.html',
  styleUrls: ['./cardlink.component.scss'],
})
export class CardlinkComponent {
  @ViewChild('cardlinkForm') cardlinkForm: ElementRef;
  requestJSON: any;

  submitForm(requestJSON: any) {
    this.requestJSON = requestJSON;
    setTimeout((_) => this.cardlinkForm.nativeElement?.submit());
  }
}
